import { authFetch } from '~/services/fetch'
import type { DeviceActionsParams, DeviceReportSearchLogRow, DeviceDetails } from '../interfaces'

export async function getDeviceActionsLogs(params: DeviceActionsParams) {
  const { orders, ...otherParams } = params
  const response = await authFetch({
    url: '/logs/device-actions',
    method: 'POST',
    data: {
      ...otherParams,
      orders: orders || [{ field: 'created_at', sort: 'desc' }],
    },
  })

  return response.data
}

export const getDeviceLogDetails = async (id: number): Promise<any> => {
  try {
      const response = await authFetch({
    url: `/logs/details/${id}`,
    method: 'GET',
  })
    if (!response.status || response.status !== 200) {
      throw new Error('Erro ao buscar detalhes do log');
    }
    return response.data; // Assumindo que a resposta é um objeto compatível com DeviceReportSearchLogRow ou uma extensão dele
  } catch (error) {
    console.error('Erro na requisição:', error);
    throw error;
  }
};
